/* Viewer for the #LaurenOnYou row.

   Opens on a square, steps with the arrows, a swipe or the arrow keys, closes
   on the cross, on Escape and on a click outside the picture. Focus is put on
   the close button when it opens and handed back to the square that opened it,
   so a keyboard is not left somewhere behind the overlay. */
(function () {
  function init(section) {
    var viewer = section.querySelector('[data-ugc-viewer]');
    if (!viewer) return;

    /* The section sits inside the product column, which the theme animates
       with a transform. A transformed ancestor becomes the containing block
       for position: fixed, so the overlay was pinned to that column instead of
       the window: the header stayed on top of it and the page showed through
       underneath. Moving it to the body puts it back on the viewport. */
    document.body.appendChild(viewer);

    var slides = [].slice.call(viewer.querySelectorAll('[data-ugc-slide]'));
    /* One row of garments per photograph, swapped with it. In a shared strip
       no two photographs hold the same clothes, so a single row underneath
       would be wrong on ten of the eleven. */
    var shops = [].slice.call(viewer.querySelectorAll('[data-ugc-shop]'));
    var openers = [].slice.call(section.querySelectorAll('[data-ugc-open]'));
    var closeBtn = viewer.querySelector('[data-ugc-close]');
    var prevBtn = viewer.querySelector('[data-ugc-prev]');
    var nextBtn = viewer.querySelector('[data-ugc-next]');
    var current = 0;
    var lastOpener = null;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== current; });
      shops.forEach(function (s, n) { s.hidden = n !== current; });
    }

    function open(i, opener) {
      lastOpener = opener || null;
      show(i);
      viewer.hidden = false;
      document.body.classList.add('overflow-hidden');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      viewer.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (lastOpener) lastOpener.focus();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(parseInt(btn.getAttribute('data-ugc-open'), 10) || 0, btn);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

    /* A click on the backdrop closes; a click on the picture or the furniture
       does not, so the arrows stay usable. */
    viewer.addEventListener('click', function (e) {
      if (e.target === viewer) close();
    });

    /* Swiping across the picture steps the same way the arrows do. Vertical
       drags are left alone so the overlay can still be scrolled. */
    var startX = null;
    var startY = null;
    viewer.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { startX = null; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    viewer.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (viewer.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('.ugc')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
